import { IconClose, IconInformation } from 'components/icons';
import { MouseEvent } from 'react';
import { useFriendStatus } from '..';

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
}

const UnfriendConfirmModal = ({ onConfirm, onCancel }: Props) => {
  const { user } = useFriendStatus();
  const { fullName } = user ?? {};
  const clickWrapper = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  return (
    <div
      className='min-w-[438px] max-w-[438px] rounded-[16px] bg-paper shadow-1'
      onClick={clickWrapper}
    >
      <div className='flex w-full flex-col space-y-[16px] px-[24px] py-[16px]'>
        <div className='flex w-full justify-end'>
          <button type='button' onClick={onCancel}>
            <IconClose className='min-h-[28px] min-w-[28px] text-text2' />
          </button>
        </div>
        <div className='flex w-full justify-center'>
          <IconInformation className='min-h-[70px] min-w-[70px] text-information' />
        </div>
        <div className='flex w-full justify-center'>
          <span className='font-[18px]'>{`Hủy kết bạn ${
            fullName ? 'với ' + fullName : ''
          } ?`}</span>
        </div>
        <div className='flex w-full justify-center space-x-[16px] border-t border-stroke pt-[11px]'>
          <button className='h-[40px] w-1/2 rounded-[6px] border bg-background' onClick={onCancel}>
            <span className='font-[600]'>Hủy</span>
          </button>
          <button className='h-[40px] w-1/2 rounded-[6px] bg-primary' onClick={onConfirm}>
            <span className='font-[600] text-paper'>Xác nhận</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnfriendConfirmModal;
